import { changeToLogin, changeToLogout } from "../../Redux/slices/userSlice";
import { store } from "./LocalStorage";
import { initUser, removeLocalStorage } from "./Token";

export const HandleLogin = (navigate, token) => {
  return async (dispatch) => {
    try {
      initUser(token);
      dispatch(changeToLogin());
      window.open("/manager", '_self');
    } catch (e) {}
  };
};

export const HandleLogOut = (navigate) => {
  return async (dispatch) => {
    try {
      removeLocalStorage();
      dispatch(changeToLogout());
      navigate("/auth");
    } catch (e) {}
  };
};
